import { Zap } from "lucide-react";

// Guided empty-state header shown at the top of every Studio tool.
export default function ToolIntro({ Icon, title, desc, accepts, costLabel, tier }) {
  return (
    <div
      data-testid="tool-intro"
      className="mb-5 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 flex items-start gap-4"
    >
      <div className="h-11 w-11 rounded-xl bg-indigo-100 flex items-center justify-center shrink-0">
        <Icon className="h-5 w-5 text-indigo-600" />
      </div>
      <div className="min-w-0">
        <h3 className="font-display font-semibold text-base">{title}</h3>
        <p className="text-slate-600 text-sm mt-0.5 leading-relaxed">{desc}</p>
        <div className="flex flex-wrap items-center gap-2 mt-2.5 text-xs">
          {accepts && (
            <span className="inline-flex items-center gap-1 bg-slate-100 text-slate-600 px-2.5 py-1 rounded-full font-medium">
              Accepts: {accepts}
            </span>
          )}
          {costLabel && (
            <span className="inline-flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-full font-medium">
              <Zap className="h-3 w-3 fill-amber-500 text-amber-500" />
              {tier ? `${tier} · ` : ""}{costLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
